import { LinkSection } from '../types/familyLinks';

export const sampleFamilyLinks: LinkSection[] = [
  {
    title: 'Utilities',
    links: [
      { id: '1', name: 'PG&E', url: 'https://www.pge.com' },
      { id: '2', name: 'Xfinity', url: 'https://www.xfinity.com' },
      { id: '3', name: 'Verizon', url: 'https://www.verizon.com' },
      { id: '4', name: 'EBMUD Water', url: 'https://www.ebmud.com' },
      { id: '5', name: 'Recology', url: 'https://www.recology.com' },
      { id: '6', name: 'USPS', url: 'https://www.usps.com' },
    ],
  },
  {
    title: 'Restaurants',
    links: [
      { id: '10', name: 'DoorDash', url: 'https://www.doordash.com' },
      { id: '11', name: 'Yelp', url: 'https://www.yelp.com' },
      { id: '12', name: 'OpenTable', url: 'https://www.opentable.com' },
      { id: '13', name: 'Resy', url: 'https://resy.com' },
      { id: '14', name: "Zachary's", url: 'https://zacharys.com' },
      { id: '15', name: 'Cheese Board', url: 'https://cheeseboardcollective.coop' },
      { id: '16', name: 'Toast', url: 'https://www.toasttab.com' },
    ],
  },
  {
    title: 'Recipes',
    links: [
      { id: '20', name: 'NYT Cooking', url: 'https://cooking.nytimes.com' },
      { id: '21', name: 'Serious Eats', url: 'https://www.seriouseats.com' },
      { id: '22', name: 'Bon Appétit', url: 'https://www.bonappetit.com' },
      { id: '23', name: 'Smitten Kitchen', url: 'https://smittenkitchen.com' },
      { id: '24', name: 'King Arthur', url: 'https://www.kingarthurbaking.com' },
      { id: '25', name: 'Food52', url: 'https://food52.com' },
      { id: '26', name: 'The Woks of Life', url: 'https://thewoksoflife.com' },
      { id: '27', name: 'Budget Bytes', url: 'https://www.budgetbytes.com' },
    ],
  },
  {
    title: 'Misc',
    links: [
      { id: '30', name: 'Amazon', url: 'https://www.amazon.com' },
      { id: '31', name: 'Costco', url: 'https://www.costco.com' },
      { id: '32', name: 'Drive', url: 'https://drive.google.com' },
      { id: '33', name: 'Calendar', url: 'https://calendar.google.com' },
      { id: '34', name: 'Netflix', url: 'https://www.netflix.com' },
      { id: '35', name: 'YouTube', url: 'https://www.youtube.com' },
      { id: '36', name: 'Spotify', url: 'https://open.spotify.com' },
      { id: '37', name: 'Strava', url: 'https://www.strava.com' },
    ],
  },
  {
    title: 'Baby',
    links: [
      { id: '40', name: 'BabyCenter', url: 'https://www.babycenter.com' },
      { id: '41', name: 'Target Baby', url: 'https://www.target.com' },
      { id: '42', name: "Carter's", url: 'https://www.carters.com' },
      { id: '43', name: 'Nanit', url: 'https://www.nanit.com' },
      { id: '44', name: 'Solid Starts', url: 'https://solidstarts.com' },
      { id: '45', name: 'Pediatrician', url: 'https://www.kp.org' },
    ],
  },
];
